import {
  Link,
  Mail,
} from "@lazarentertainment/web-design-system/components/iconOutline"
import { CheckCircleSolid } from "@lazarentertainment/web-design-system/components/iconSolid"
import {
  Facebook,
  LinkedIn,
  Threads,
  X,
} from "@lazarentertainment/web-design-system/components/logo"
import { useChannelContext } from "client/components/channel"
import { Button } from "client/designSystem/Button"
import {
  DialogBody,
  DialogCloseButton,
  DialogContent,
  DialogHeader,
  DialogOverlay,
  DialogPortal,
  DialogRoot,
  DialogTrigger,
} from "client/designSystem/Dialog"
import { LinkStyledAsButton } from "client/designSystem/LinkStyledAsButton"
import { ReactNode } from "react"
import useCopyToClipboardWithNotification from "shared/hooks/useCopyToClipboardWithNotification"
import { openUrlPopup } from "shared/utils/openUrlPopup"

import styles from "./ShareDialog.module.css"

export type ShareDialogProps = {
  trigger: ReactNode
}

export const ShareDialog = ({ trigger }: ShareDialogProps) => {
  const { title: channelTitle } = useChannelContext()
  const shareUrl = window.location.toString()
  const shareMessage = "Come join the show on Stage TEN!"
  const [copyToClipboard, showCopyNotification] =
    useCopyToClipboardWithNotification()
  return (
    <DialogRoot>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogPortal>
        <DialogOverlay />
        <DialogContent data-size="md">
          <DialogHeader
            title="Share this stream"
            description={channelTitle}
            topRightContent={<DialogCloseButton />}
          />
          <DialogBody>
            <div className={styles.shareList}>
              <Button
                variant="outline"
                size="lg"
                icon={Facebook}
                onClick={() =>
                  openUrlPopup(
                    `https://www.facebook.com/share.php?&quote=${encodeURIComponent(shareMessage)}&u=${shareUrl}`,
                  )
                }
              >
                Share on Facebook
              </Button>
              <Button
                variant="outline"
                size="lg"
                icon={X}
                onClick={() =>
                  openUrlPopup(
                    `https://x.com/intent/post?text=${encodeURIComponent(shareMessage)}&url=${shareUrl}`,
                  )
                }
              >
                Share on X
              </Button>
              <Button
                variant="outline"
                size="lg"
                icon={Threads}
                onClick={() =>
                  openUrlPopup(
                    `https://threads.net/intent/post?text=${encodeURIComponent(`${shareMessage}\n\n${shareUrl}`)}`,
                  )
                }
              >
                Share on Threads
              </Button>
              <Button
                variant="outline"
                size="lg"
                icon={LinkedIn}
                onClick={() =>
                  openUrlPopup(
                    `https://www.linkedin.com/shareArticle?&url=${shareUrl}&mini=true`,
                  )
                }
              >
                Share on LinkedIn
              </Button>
              <LinkStyledAsButton
                variant="outline"
                size="lg"
                icon={Mail}
                rel="noopener noreferrer"
                target="_blank"
                href={`mailto:?&subject=${shareMessage}&body=${encodeURIComponent(`${shareMessage}\n\n${shareUrl}`)}`}
              >
                Share via Email
              </LinkStyledAsButton>
              <Button
                variant="outline"
                size="lg"
                icon={showCopyNotification ? CheckCircleSolid : Link}
                onClick={() => {
                  copyToClipboard(shareUrl)
                }}
              >
                {showCopyNotification ? "Copied!" : "Copy link"}
              </Button>
            </div>
          </DialogBody>
        </DialogContent>
      </DialogPortal>
    </DialogRoot>
  )
}
